import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ScreenHeader extends Component
{

	static propTypes = {
		value: PropTypes.string.isRequired
	};

	render() {
		return (
			<div className="card-header">
				<h4 className="card-title">{this.props.value}</h4>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/general/ScreenHeader.js